import React from 'react';

import Appearance from '../Appearance';

import './styles.css';

export default props => {
  return (
    <div className="TextBlock" style={props.style}>
      <div className="TextBlock__title">{props.title}</div>
      <Appearance type="up">
        <div className="TextBlock__content">{props.children}</div>
      </Appearance>
    </div>
  );
};
